export default {
  algoliaAppId: document.head.querySelector('meta[name="algolia-search-api-app-id"]')?.content,
  algoliaApiKey: document.head.querySelector('meta[name="algolia-search-api-key"]')?.content,
  algoliaIndexPrefix: document.head.querySelector('meta[name="algolia-search-api-index-prefix"]')?.content
};
